module.exports = __webpack_public_path__ + "img/directdebit-small.a7ab8887.svg";